import {
  ConversationPlatform,
  getConversationStatus,
  MinimalConversation,
} from "@redotech/redo-model/conversation";
import { getCustomerDisplayName } from "@redotech/redo-model/customer";
import { RedoCheckbox } from "@redotech/redo-web/arbiter-components/checkbox/redo-checkbox";
import { Flex } from "@redotech/redo-web/flex";
import { RedoSupportChannelBadge } from "@redotech/redo-web/support/redo-support-channel-badge";
import { Text } from "@redotech/redo-web/text";
import { getDateString } from "@redotech/util/date-format";
import { memo } from "react";
import { ConversationStatusPill } from "../conversation-status-pill";

export const DetailedConversationCard = memo(function DetailedConversationCard({
  conversation,
  onToggle,
  isSelected,
  showCheckbox = false,
}: {
  conversation: MinimalConversation;
  onToggle?: () => void;
  isSelected?: boolean;
  showCheckbox?: boolean;
}) {
  const mostRecentMessage = conversation.lastMessage;

  return (
    <Flex
      align="flex-start"
      borderColor="primary"
      borderStyle="solid"
      borderWidth="1px"
      dir="row"
      gap="md"
      p="lg"
      radius="lg"
    >
      {showCheckbox && (
        <RedoCheckbox
          setValue={onToggle || (() => {})}
          value={isSelected || false}
        />
      )}

      <Flex dir="column" gap="sm" grow={1}>
        <Flex align="center" gap="sm" justify="space-between">
          <Flex align="center" gap="sm">
            <ConversationStatusPill
              conversationStatus={getConversationStatus(conversation)}
            />
            <RedoSupportChannelBadge platform={conversation.platform} />
          </Flex>
        </Flex>

        <Flex dir="column" gap="xs">
          <Text fontSize="md" fontWeight="medium">
            {getCustomerDisplayName(conversation.customer)}
          </Text>
          {conversation.platform === ConversationPlatform.EMAIL &&
            conversation.subject && (
              <Text fontSize="sm" textColor="secondary">
                Subject: {conversation.subject}
              </Text>
            )}
          <Flex justify="space-between">
            <Text fontSize="xs" textColor="secondary">
              {conversation.customer?.name || "Unknown customer"}
            </Text>
            <Text fontSize="xs" textColor="tertiary">
              {getDateString(new Date(conversation.lastResponseAt))}
            </Text>
          </Flex>
        </Flex>

        {mostRecentMessage?.content && (
          <Flex
            borderColor="primary"
            borderStyle="solid"
            borderWidth="1px"
            p="sm"
            radius="md"
            topLeftRadius="none"
          >
            <Text fontSize="sm" textColor="secondary">
              {mostRecentMessage.content.length > 300
                ? `${mostRecentMessage.content.slice(0, 300)}...`
                : mostRecentMessage.content}
            </Text>
          </Flex>
        )}
      </Flex>
    </Flex>
  );
});
